import {Component, OnInit, Injectable} from '@angular/core';

@Component({
    selector: 'my-footer',
    template: require('./footer.component.html'),
    styles: [require('./footer.component.scss')]
})
@Injectable()
export class FooterComponent implements OnInit {

    STATIC_URL_ABOUT_US: string = process.env.STATIC_URL_ABOUT_US || '';
    STATIC_URL_CONTACT_US: string = process.env.STATIC_URL_CONTACT_US || '';
    STATIC_URL_MEDPRO_ASSISTANT: string = process.env.STATIC_URL_MEDPRO_ASSISTANT || '';

    constructor() {
    }

    ngOnInit(): void {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/footer/footer.component.ts